import { MatBadgeModule } from '@angular/material/badge';
import { UnreadMessagesService } from '../../domain/service/unreadMessages.service';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

/**
 * Native-style bottom tab bar shown on mobile (native apps + narrow web
 * viewports). Replaces the hamburger/sidenav navigation on small screens.
 * Desktop keeps the sidenav. Respects the iOS home-indicator safe area.
 */
@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatBadgeModule],
  template: `
    <nav class="bottom-nav">
      <a class="tab" routerLink="/app" routerLinkActive="tab--active"
         [routerLinkActiveOptions]="{ exact: true }">
        <mat-icon fontIcon="home"></mat-icon>
        <span>Home</span>
      </a>
      <a class="tab" routerLink="/app/payments" routerLinkActive="tab--active">
        <mat-icon fontIcon="paid"></mat-icon>
        <span>Pay</span>
      </a>
      <a class="tab" routerLink="/app/properties" routerLinkActive="tab--active">
        <mat-icon fontIcon="domain"></mat-icon>
        <span>Properties</span>
      </a>
      <a class="tab" routerLink="/app/messages" routerLinkActive="tab--active">
        <mat-icon fontIcon="mail" [matBadge]="unread.count()" [matBadgeHidden]="unread.count() === 0" matBadgeColor="warn" matBadgeSize="small"></mat-icon>
        <span>Messages</span>
      </a>
      <a class="tab" routerLink="/app/profile" routerLinkActive="tab--active">
        <mat-icon fontIcon="account_circle"></mat-icon>
        <span>Profile</span>
      </a>
    </nav>
  `,
  styles: [`
    .bottom-nav {
      position: fixed;
      left: 0; right: 0; bottom: 0;
      z-index: 1000;
      display: flex;
      background: #ffffff;
      border-top: 1px solid rgba(0, 0, 0, 0.12);
      /* Lift the tappable row above the iOS home indicator. */
      padding-bottom: env(safe-area-inset-bottom, 0px);
    }
    .tab {
      flex: 1 1 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;
      padding: 6px 0 4px;
      text-decoration: none;
      color: rgba(0, 0, 0, 0.55);
      font-size: 11px;
      line-height: 1;
      -webkit-tap-highlight-color: transparent;
    }
    .tab mat-icon {
      width: 24px; height: 24px; font-size: 24px;
    }
    .tab span {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tab--active {
      color: #05477B;
    }
  `],
})
export class BottomNavComponent {
  constructor(public unread: UnreadMessagesService) {}
}
